import script from "./user-badges.vue?vue&type=script&setup=true&lang=js"
export * from "./user-badges.vue?vue&type=script&setup=true&lang=js"

import "./user-badges.vue?vue&type=style&index=0&id=551cb566&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-551cb566"]])

export default __exports__